"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementsGroup = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var ElementsGroup_styles_1 = __importDefault(require("./ElementsGroup.styles"));
function ElementsGroup(_a) {
    var className = _a.className, _b = _a.position, position = _b === void 0 ? 'left' : _b, children = _a.children, _c = _a.noWrap, noWrap = _c === void 0 ? false : _c, _d = _a.grow, grow = _d === void 0 ? false : _d, _e = _a.spacing, spacing = _e === void 0 ? 'md' : _e, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "position", "children", "noWrap", "grow", "spacing", "themeOverride"]);
    var classes = ElementsGroup_styles_1.default({
        grow: grow,
        noWrap: noWrap,
        spacing: spacing,
        position: position,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    var items = react_1.Children.toArray(children).map(function (child) {
        return react_1.default.cloneElement(child, { className: clsx_1.default(classes.child, child.props.className) });
    });
    return (react_1.default.createElement("div", __assign({ className: className }, others),
        react_1.default.createElement("div", { className: classes.elementsGroup }, items)));
}
exports.ElementsGroup = ElementsGroup;
ElementsGroup.displayName = '@mantine/core/ElementsGroup';
